<template>
  <component
    :is="baseComponent"
    :to="link.path ? link.path : '/'"
    :class="['nav-item', { active: isActive }]"
    tag="li"
  >
    <a
      v-if="isMenu"
      class="nav-link sidebar-menu-item"
      :aria-expanded="!collapsed"
      data-toggle="collapse"
      @click="collapseMenu"
    >
      <img
        v-if="link.image"
        :src="link.image"
        alt="image"
        class="sidebar-item-image"
      />
      <span class="sidebar-item-content">
        {{ link.name }}
        <span v-if="link.count" class="count">{{link.count}}</span>
        <b class="caret"></b>
      </span>
    </a>
    <div v-if="$slots.default || this.isMenu">
      <el-collapse-transition>
        <ul class="nav" v-show="!collapsed">
          <slot></slot>
        </ul>
      </el-collapse-transition>
    </div>

    <slot
      name="title"
      v-if="children.length === 0 && !$slots.default && link.path"
    >
      <component
        :to="link.path"
        @click.native="linkClick"
        :is="elementType(link, false)"
        :class="{ active: link.active }"
        class="nav-link"
        :target="link.target"
        :href="link.path"
      >
        <template v-if="addLink">
          <img
            v-if="link.image"
            :src="link.image"
            alt="image"
            class="sidebar-item-image"
          />
          <span class="sidebar-normal" :class="{ 'coming-soon': comingSoon }">{{
            link.name
          }}</span>
        </template>
        <template v-else>
          <img
            v-if="link.image"
            :src="link.image"
            alt="image"
            class="sidebar-item-image"
          />
          <span :class="{ 'coming-soon': comingSoon }">{{ link.name }}</span>
        </template>
      </component>
    </slot>
  </component>
</template>
<script>
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";

export default {
  name: "sidebar-item",
  components: {
    [CollapseTransition.name]: CollapseTransition,
  },
  props: {
    menu: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          path: "",
          children: [],
          count: {
            type: Number,
            default: null,
          }
        };
      },
    },
    comingSoon: {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild,
    };
  },
  inject: {
    addLink: { default: null },
    removeLink: { default: null },
    autoClose: {
      default: true,
    },
  },
  data() {
    return {
      children: [],
      collapsed: true,
    };
  },
  computed: {
    baseComponent() {
      return this.isMenu || this.link.isRoute ? "li" : "router-link";
    },
    isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive() {
      if (this.$route && this.$route.path) {
        let matchingRoute = this.children.find((c) =>
          this.$route.path.startsWith(c.link.path),
        );
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    addChild(item) {
      const index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild(item) {
      const tabs = this.children;
      const index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType(link, isParent = true) {
      if (link.isRoute === false) {
        return isParent ? "li" : "a";
      } else {
        return "router-link";
      }
    },
    linkAbbreviation(name) {
      const matches = name.match(/\b(\w)/g);
      return matches.join("");
    },
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
    collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    },
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  },
};
</script>
<style>
.sidebar-menu-item {
  cursor: pointer;
  position: relative;
}
.sidebar-item-image {
  width: 24px;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
  margin-right: 20px;
}
.sidebar-item-content {
  max-width: calc(100% - 24px) !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
}
.coming-soon {
  color: lightgrey !important;
}
.count{
  position: absolute;
  right: 30px;
  top: 10px;
  color: #eeeeee !important;
  background-color: #979797;
  padding: 5px;
  border-radius: 11px;
  font-size: 12px !important;
}
</style>
